import { RegisterComponent } from '@feng3d/ecs';
import { CameraHelper } from '../../thirdparty/three/imports';
import { Camera3D } from '../cameras/Camera3D';
import { Component3D } from '../core/Component3D';

declare module '@feng3d/ecs'
{
    interface ComponentMap { CameraHelper3D: CameraHelper3D; }
}

/**
 * 包装`three`中`CameraHelper`。
 */
@RegisterComponent({ name: 'CameraHelper3D' })
export class CameraHelper3D extends Component3D
{
    _helper: CameraHelper;

    camera: Camera3D;

    init()
    {
        super.init();
        this._helper = new CameraHelper(this.camera?._camera);

        this._entity._group.add(this._helper);
    }

    destroy(): void
    {
        this._entity._group.remove(this._helper);

        this._helper.dispose();
        this._helper = null;

        super.destroy();
    }

    update()
    {
        this._helper.update();
    }
}
